module.exports = __webpack_public_path__ + "img/favicon.2b991935.svg";